<div class="title" [ngClass]="containerClass()" (click)="toggleExpandedState()">
    <ng-container *ngIf="offerBadgeTemplate && activeOption && activeOption.badge">
        <ng-container
            *ngTemplateOutlet="offerBadgeTemplate; context: { $implicit: { style: activeOption.badge.cssClass, title: activeOption.badge.text } }" />
    </ng-container>

    <ng-container *ngIf="!isIconTemplate; else iconTemplate">
        <span class="group-title" [style.color]="textColor">
            <ng-container
                *ngTemplateOutlet="
                    titleTemplate || defaultTitleTemplate;
                    context: { $implicit: activeOption ? activeOption.name : noSelectionText }
                " />
            <ng-template #defaultTitleTemplate let-title>{{ title }}</ng-template>
        </span>
        @if (expandable()) {
            @if (expanded()) {
                <vn-icon class="group-arrow dropdown-icon" name="theme-up" size="14"></vn-icon>
            } @else {
                <vn-icon class="group-arrow dropdown-icon" name="theme-down" size="14"></vn-icon>
            }
        }
    </ng-container>
    <ng-template #iconTemplate>
        <ng-content select="[icon]" />
    </ng-template>
</div>
<div
    [popper]="dropDown"
    [popperPlacement]="placement()"
    [popperApplyArrowClass]="'withoutArrow'"
    [popperTrigger]="NgxPopperjsTriggers.click"
    [popperApplyClass]="popperClass"
    [popperPreventOverflow]="false"
    [popperAppendTo]="isOnEdpModal ? '.in-overlay.event-details' : viewport"
    [popperBoundaries]="viewport"
    [popperFlip]="popperFlip"></div>
<popper-content #dropDown>
    <div class="select" [ngClass]="contentClass">
        <ng-container *rxFor="let option of _options(); trackBy: optionTrackBy">
            @switch (option.type) {
                @case (optionType.Regular) {
                    <ng-container *ngTemplateOutlet="optionTemplate || defaultOptionTemplate; context: { $implicit: option }" />
                }
                @case (optionType.Special) {
                    <div class="option divider"></div>
                    <div class="option" [msAutomation]="option.automation" (click)="selectSpecialOption(option)">
                        <span class="option-name">{{ option.name }}</span>
                        <vn-icon
                            size="12"
                            class="dropdown-popper-icon"
                            [name]="getArrowClass(option.arrowType)"
                            [ngClass]="getArrowClass(option.arrowType) === 'theme-right' ? 'dropdown-right-icon' : 'dropdown-left-icon'"></vn-icon>
                    </div>
                }
            }
        </ng-container>
    </div>
</popper-content>

<ng-template #defaultOptionTemplate let-option>
    <div
        class="option"
        [class.active]="activeOption && activeOption.id === option.id"
        [msAutomation]="option.automation"
        (click)="selectOption(option)">
        @if (offerBadgeTemplate && option && option.badge) {
            <ng-container
                *ngTemplateOutlet="offerBadgeTemplate; context: { $implicit: { style: option.badge.cssClass, title: option.badge.text } }" />
        }
        {{ option.name }}
        @if (option.hasNewBadge) {
            <span class="dropdown-option-badge">{{ sitecore.globalMessages.NewBadgeText }}</span>
        }
    </div>
</ng-template>
